import { MentorGroupMembersContainer } from "../members/list/MentorGroupMembersCard"

function GroupMembersAugmentation({ groupId }: { groupId?: number }) {
  return <MentorGroupMembersContainer groupId={groupId} />
}

export default GroupMembersAugmentation
